import { GatsbyImage } from 'gatsby-plugin-image';
import React, { useEffect, useRef } from 'react';

import { ThemeProvider } from 'styled-components';
import { THEME_DEFAULT } from '../../../theme/theme';
// import ButtonLink from '../../shared/button-link';
import parse from 'html-react-parser';
import { ButtonLink } from '../../common/button-link';

import {
	AuthorDate,
	AuthorImage, AuthorName,
	AuthorProfile,
	AuthorSocial,
	AuthorText,
	AuthorWrapper,
	BodyWrapper,
	Container,
	Content,
	ContentWrapper,
	DownloadContainer,
	Introduction,
	Label,
	SocialLink,
	Wrapper,
} from './detail.styles';

const Detail = ({
	title, author, body, download, date, introduction, subheading, enableShare, pageURL
}) => {
	const dateFormat = (date) => {
		const dateSplit = date.split(' ');
		return `${dateSplit[1]} ${dateSplit[0]} ${dateSplit[2]}`;
	};

	const bodyRef = useRef();
	useEffect(() => {
		bodyRef.current.querySelectorAll('img').forEach((element) => {
			if (element.getAttribute('alt')) {
				// Add image description if exist
				const imgDescription = document.createElement('div');
				imgDescription.className = 'image-description';
				imgDescription.innerHTML = element.getAttribute('alt');
				element.insertAdjacentElement('afterend', imgDescription);
			}

			// Set margin on image parent element
			element.parentElement.className = 'image-wrapper';
		});

		bodyRef.current.querySelectorAll('blockquote').forEach((element) => {
			const authorName = element.querySelector('strong');
			const authorTitle = element.querySelector('em');

			const quoteOpenContainer = document.createElement('span');
			quoteOpenContainer.className = 'quote-credit-open';
			quoteOpenContainer.innerHTML = '“';
			element.prepend(quoteOpenContainer);
			const quoteCloseContainer = document.createElement('span');
			quoteCloseContainer.className = 'quote-credit-close';
			quoteCloseContainer.innerHTML = '”';
			element.append(quoteCloseContainer);


			const quoteCredit = document.createElement('div');
			quoteCredit.className = 'quote-credit';

			if (authorName) {
				quoteCredit.appendChild(authorName);
			}

			if (authorTitle) {
				quoteCredit.appendChild(authorTitle);
			}

			if (authorName || authorTitle) {
				element.appendChild(quoteCredit);
			}
		});
	}, []);

	const shareArticle = (media) => {
		const encodedMessage = encodeURIComponent(title)
		const url = encodeURIComponent(pageURL);

		if (media === 'twitter') {
			return `https://twitter.com/intent/tweet?text=${encodedMessage}&url=${url}`;
		} else if (media === 'facebook') {
			return `https://www.facebook.com/sharer/sharer.php?u=${url}&quote=${encodedMessage}`;
		} else if (media === 'linkedin') {
			return `https://www.linkedin.com/shareArticle?url=${url}&title=${encodedMessage}`;
		}
	};

	const parsedBody = parse(body, {
		replace: (domNode) => {
			if (domNode.name === 'img') {
				const { src, ...rest } = domNode.attribs;
				return <img src={`${src}?auto=format&w=1040`} {...rest} />;
			}
		},
	});

	const isBrowser = typeof window !== `undefined`;
	return (
		<ThemeProvider theme={THEME_DEFAULT}>
			<Container>
				<Wrapper>
					<ContentWrapper>
						<AuthorWrapper>
							{author && <AuthorProfile>
								{author.image && <AuthorImage><GatsbyImage image={author.image.gatsbyImageData} style={{ height: '100%', width: '100%' }} /></AuthorImage>}
								<AuthorName>{author.name}</AuthorName>
							</AuthorProfile>}
							{subheading && <AuthorText>{subheading}</AuthorText>}
							<AuthorDate>{dateFormat(date)}</AuthorDate>
							{enableShare && <AuthorSocial>
								<SocialLink href={shareArticle('twitter')} target="_blank">
									<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M23.954 2.56897C23.069 2.95797 22.124 3.22297 21.129 3.34397C22.143 2.73297 22.923 1.76997 23.292 0.620972C22.341 1.17597 21.287 1.57997 20.165 1.80497C19.269 0.845972 17.992 0.245972 16.574 0.245972C13.857 0.245972 11.654 2.44897 11.654 5.16297C11.654 5.55297 11.699 5.92797 11.781 6.28697C7.691 6.09397 4.066 4.12997 1.64 1.16097C1.213 1.88297 0.974 2.72197 0.974 3.63597C0.974 5.34597 1.844 6.84897 3.162 7.73197C2.355 7.70597 1.596 7.48397 0.934 7.11597V7.17697C0.934 9.56197 2.627 11.551 4.88 12.004C4.467 12.115 4.031 12.175 3.584 12.175C3.27 12.175 2.969 12.145 2.668 12.089C3.299 14.042 5.113 15.466 7.272 15.506C5.592 16.825 3.463 17.611 1.17 17.611C0.78 17.611 0.391 17.588 0 17.544C2.189 18.938 4.768 19.753 7.557 19.753C16.611 19.753 21.556 12.257 21.556 5.76697C21.556 5.55797 21.556 5.34697 21.541 5.13697C22.502 4.44797 23.341 3.57697 24.001 2.58897L23.954 2.56897Z" fill="#232122" />
									</svg>
								</SocialLink>
								<SocialLink href={shareArticle('facebook')} target="_blank">
									<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M8.33125 3.32083H10.1571V0.140833C9.84208 0.0975 8.75875 0 7.49708 0C4.86458 0 3.06125 1.65583 3.06125 4.69917V7.5H0.15625V11.055H3.06125V20H6.62292V11.0558H9.41042L9.85292 7.50083H6.62208V5.05167C6.62292 4.02417 6.89958 3.32083 8.33125 3.32083Z" fill="#232122" />
									</svg>
								</SocialLink>
								<SocialLink href={shareArticle('linkedin')} target="_blank">
									<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
										<g clipPath="url(#clip0)">
											<path d="M19.9951 20V19.9991H20.0001V12.6641C20.0001 9.07581 19.2276 6.31165 15.0326 6.31165C13.0159 6.31165 11.6626 7.41831 11.1101 8.46748H11.0517V6.64665H7.07422V19.9991H11.2159V13.3875C11.2159 11.6466 11.5459 9.96331 13.7017 9.96331C15.8259 9.96331 15.8576 11.95 15.8576 13.4991V20H19.9951Z" fill="#232122" />
											<path d="M0.330078 6.64746H4.47675V20H0.330078V6.64746Z" fill="#232122" />
											<path d="M2.40167 0C1.07583 0 0 1.07583 0 2.40167C0 3.7275 1.07583 4.82583 2.40167 4.82583C3.7275 4.82583 4.80333 3.7275 4.80333 2.40167C4.8025 1.07583 3.72667 0 2.40167 0V0Z" fill="#232122" />
										</g>
										<defs>
											<clipPath id="clip0">
												<rect width="20" height="20" fill="white" />
											</clipPath>
										</defs>
									</svg>
								</SocialLink>
							</AuthorSocial>}
						</AuthorWrapper>
						<BodyWrapper>
							<ContentWrapper>
								<Label>Introduction</Label>
								<Introduction dangerouslySetInnerHTML={{ __html: introduction }} />
								<Content ref={bodyRef}>{parsedBody}</Content>
								{download && <DownloadContainer><ButtonLink link={{ label: "Download PDF", model: { apiKey: "link_download" }, file: download }} /></DownloadContainer>}
							</ContentWrapper>
						</BodyWrapper>
					</ContentWrapper>
				</Wrapper>
			</Container>
		</ThemeProvider>
	);
};

export default Detail;
